<!--Home:组卷-考试-首页 2022/09/26 17:23:47 YuAng-->
<template>
  <div class="yj-sso">
    {{ tip }}
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { ssoCheck } from "@/api/login";
export default {
  name: 'Home',
  data () {
    return {
      redirect: {
        account: '/system/student',
        single: '/v2/exam/index',
        multiple: '/v2/exam/index',
        gaokao: '/exam/gaokao',
        marking: '/v2/marking/index',
        sheet: '/v2/card/index',
        archives: '/study/archives/student'
      },
      tip: 'e卷通阅卷加载中...'
    }
  },

  computed: {
    ...mapGetters({
      userInfo: "getUserInfo"
    }),
    isYJPermission () {
      return this.$store.getters.isYJPermission
    },
    isRegionPlatform () {
      const platform = this.$store.state.v2.platform || sessionStorage.getItem('LoginPlatform')
      return platform === 'region'
    }
  },

  async created () {
    let iframe = 'zujuan'
    if (this.$route.query.xep_url) {
      iframe = 'xep'
    }
    sessionStorage.setItem('yj_iframe', iframe)
    if (iframe === 'xep') {
      this.appendXep()
    }
    this.$store.commit('setPlatform', this.$route.params.platform)
    try {
      const resp = await ssoCheck(process.env.VUE_APP_SSO_URL)
      const user = JSON.parse(YJ_SCHOOL_STORAGE.getItem('userInfo'))
      if (resp.loginName && user.loginName === resp.loginName) {
        this.jumpNext(user)
      } else {
        this.syncLogin()
      }
    } catch (error) {
      this.$confirm(error.message || error, "同步登录异常", { type: "error", confirmButtonText: "重新登录" }).then(this.syncLogin).catch(() => { });
    }
  },
  methods: {
    jumpNext: function (user) {
      // 没有开通阅卷服务，可以制卡
      if (!this.isYJPermission) {
        this.$router.push({ path: this.redirect.sheet, query: this.$route.query })
        return
      }
      YJ_SCHOOL_STORAGE.removeItem('url_before_login')
      const { redirect, action } = this.$route.query
      if (redirect) {
        let query = {}
        // 来自组卷制卡
        if (action === 'create' && redirect === 'sheet') {
          // scene=1，组卷中心发起
          // scene=2，校本发起
          const { paperId, gradeId, courseId, scene } = this.$route.query
          query = { paperId, gradeId, courseId, scene }
        }
        let path = this.redirect.sheet
        // 同步检测权限
        const menus = JSON.parse(window.YJ_SCHOOL_STORAGE.getItem("menus"));
        if (redirect === 'account') {
          const menu = menus.find(item => item.permCode === 'System')
          if (menu) {
            if (menu.children && menu.children.length) {
              path = menu.children[0].moduleUrl
            } else {
              path = this.redirect.account
            }
          } else {
            const message = 'e卷通阅卷：抱歉，您没有权限访问该模块，请联系“' + user.schoolName + '”的管理员'
            this.$message.error(message)
            return
          }
        } else if (this.redirect[redirect]) {
          path = this.redirect[redirect]
        }
        else {
          const list = menus.filter(item => item.isShow === 0)
          if (list.length > 0 && list.some(s => s.moduleUrl === redirect)) {
            path = redirect
          }
        }
        this.$router.push({ path, query })
      } else {
        this.$router.push({ path: '/v2/exam/index' })
      }
    },
    syncLogin: function () {
      YJ_SCHOOL_STORAGE.removeItem('token')
      YJ_SCHOOL_STORAGE.setItem('url_before_login', location.href)
      this.$router.push('/sso-login')
    },
    appendXep: function () {
      const xUrl = new URL(decodeURIComponent(this.$route.query.xep_url))
      const link = xUrl.origin + '/js/xep.js';
      var tracker = document.createElement("script");
      tracker.setAttribute("src", link);
      tracker.setAttribute("id", 'xep-script');
      tracker.setAttribute("data-biz", 'iframe');
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(tracker, s);
      this.initXepSdk()
    },
    initXepSdk: function () {
      if (window.XEP) {
        window.XEP.init({
          window: {
            id: 'yj',
            left: 0,
            top: 0
          },
          message: {
            onReceive: resp => {
              console.log('xep msg', resp)
            }
          }
        })
      } else {
        setTimeout(() => {
          console.log('try init xep sdk')
          this.initXepSdk()
        }, 1 * 1000);
      }
    }
  }
}
</script>
<style scoped>
.yj-sso {
  padding: 30px;
  text-align: center;
  color: #999;
}
</style>